<template>
    <v-main>
        <v-container  v-if="blogpost">
            <head>
                <title>Foraje -- {{blogpost.title}}</title>
                <meta name="description" :content="blogpost.post_summary">
            </head>
            <v-row   v-if="issomethingloading && !blogpost.length">
                <v-col cols="12" class="text-center">
                    <v-progress-circular
                            :size="100"
                            :width="7"
                            color="primary"
                            indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
            <v-row   justify="center" class="my-5" v-else>
                <v-col cols="12" sm="8">
                    <v-card flat class="transparent">
                        <v-card-title primary-title class="layout justify-center">
                            <div>
                                <div class="headline justify-center">{{blogpost.title}}</div>
                                <div class=" grey--text text-md-center" v-if="blogpost.subtitle">{{blogpost.subtitle}}</div>
                                <div class="text-right"><router-link :to="'/profiles/' + blogpost.author.slug">{{blogpost.author.name}}</router-link></div>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="8" v-if="compiledMarkdownBlogPost">
                    <v-card >
                        <v-card-text>
                            <div v-html="compiledMarkdownBlogPost" class="ma-3"></div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-divider></v-divider>

        <v-container  v-if="authorsotherblogposts && authorsotherblogposts.length">
            <h2>Other Posts By <router-link :to="'/profiles/' + blogpost.author.slug">{{blogpost.author.name}}</router-link></h2>
            <v-row >
                <v-col cols="12" sm="4" v-for="authorsotherblogpost of authorsotherblogposts" :key="authorsotherblogpost.id">
                    <v-card hover :to="'/blog/posts/' + authorsotherblogpost.slug">
                        <v-card-title primary-title>
                            <div class="cardTitle">
                                <h3 align="center">{{authorsotherblogpost.title}}</h3>
                                <p class="text-center grey--text" v-if="authorsotherblogpost.subtitle">{{authorsotherblogpost.subtitle}}</p>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>


        <v-container  v-if="generalotherblogposts && generalotherblogposts.length">
            <h2>Other Posts</h2>
            <v-row >
                <v-col cols="12" sm="4" v-for="generalotherblogpost of generalotherblogposts" :key="generalotherblogpost.id">
                    <v-card hover :to="'/blog/posts/' + generalotherblogpost.slug">
                        <v-card-title primary-title>
                            <div class="cardTitle">
                                <h3 align="center">{{generalotherblogpost.title}}</h3>
                                <p class="text-center grey--text" v-if="generalotherblogpost.subtitle">{{generalotherblogpost.subtitle}}</p>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>


    </v-main>
</template>

<script>
import axios from 'axios';
import marked from 'marked';
import DOMPurify from 'dompurify';


export default {
  name: 'SpecificBlogPost',
  data: () => ({

    blogpost: [],
    generalotherblogposts: [],
    authorsotherblogposts: [],
    errors: [],
    generalblogpostpageCount: 1,
    authorsblogpostpageCount: 1,
    issomethingloading: false,
    generalotherblogpostsfullresponse: [],
    authorsotherblogpostsfullresponse: [],
  }),

  methods: {
    GetBlogPost() {
      this.blogpost = [];
      this.issomethingloading = true;
      axios.get(`content/blogs/posts/all/${this.$route.params.slug}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.blogpost = response.data;
        })
        .then(() => { this.issomethingloading = false; })
        .then(() => {
          this.GetAuthorsOtherPosts();
        })
        .then(() => {
          this.GetGeneralOtherPosts();
        })
        .catch((e) => {
          this.errors.push(e);
          this.issomethingloading = false;
        });
    },
    GetGeneralOtherPosts() {
      this.generalotherblogposts = [];
      this.issomethingloading = true;
      return axios.get(`${'content/blogs/posts/all/?page='}${this.generalblogpostpageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.generalotherblogposts = response.data.results;
          this.generalotherblogpostsfullresponse = response.data;
        })
        .then(() => { this.issomethingloading = false; })
        .catch((e) => {
          this.errors.push(e);
          this.issomethingloading = false;
        });
    },
    GetAuthorsOtherPosts() {
      this.authorsotherblogposts = [];
      const authorSlug = this.blogpost.author.slug;
      this.issomethingloading = true;
      return axios.get(`content/blogs/posts/by/author/${authorSlug}/?page=${this.authorsblogpostpageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.authorsotherblogposts = response.data.results;
          this.authorsotherblogpostsfullresponse = response.data;
        })
        .then(() => { this.issomethingloading = false; })
        .catch((e) => {
          this.errors.push(e);
          this.issomethingloading = false;
        });
    },
    GeneralBlogPostsLoadNextBatch() {
      if (this.generalotherblogpostsfullresponse.next != null) {
        this.generalblogpostspageCount += 1;
        this.GetGeneralOtherPosts();
      }
    },

    GeneralBlogPostsLoadPreviousBatch() {
      this.generalblogpostspageCount -= 1;
      this.GetGeneralOtherPosts();
    },
    AuthorsBlogPostsLoadNextBatch() {
      if (this.authorsotherblogpostsfullresponse.next != null) {
        this.authorsblogpostspageCount += 1;
        this.GetAuthorsOtherPosts();
      }
    },

    AuthorsBlogPostsLoadPreviousBatch() {
      this.authorsblogpostspageCount -= 1;
      this.GetAuthorsOtherPosts();
    },
  },
  computed: {
    compiledMarkdownBlogPost() {
      return DOMPurify.sanitize(marked(this.blogpost.post));
    },
  },

  created() {
    // Not super elegant, but hey, it works.
    this.GetBlogPost();
  },
  watch: {
    '$route.params.slug': function () {
      this.GetBlogPost();
    },
  },

};
</script>

<style scoped>
    .otherPostsSummary{
        word-break: break-word;
    }
    .cardTitle{
        width: 100%;
    }
</style>
